export default {
  title: 'Customer Enrollment reports',
  tableHeaderActionTooltip: 'Create new Customer Enrollment report',
  dialog: {
    title: {
      generateReport: 'Generate Customer Enrollment report',
      deleteReport: 'Delete Customer Enrollment report',
      cancelReport: 'Cancel Customer Enrollment report',
      regenerateReport: 'Regenerate Customer Enrollment report',
      retryReport: 'Retry Customer Enrollment report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Customer Enrollment report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter Customer Enrollment report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Statuses',
      placeholder: 'Select statuses'
    },
    operators: {
      label: 'Operator',
      placeholder: 'Select operators'
    },
    recoveryTokenNotificationMethod: {
      label: 'Notification Method',
      placeholder: 'Select notification method'
    },
    operationIds: {
      label: 'Operation id(s)',
      placeholder: 'Enter operation id(s)'
    },
    customerMsisdns: {
      label: 'Customer phone number(s)',
      placeholder: 'Enter customer phone number(s)'
    },
    providerNames: {
      label: 'Provider(s) name',
      placeholder: 'Select provider(s) name'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    operationIds: {
      label: 'Operation Id(s)'
    },
    customerMsisdn: {
      label: 'Customer phone number(s)'
    },
    providerName: {
      label: 'Provider(s) name'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
